import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Tables } from "@/integrations/supabase/types";

type Lead = Tables<"leads">;

export const BenefitsRetirement = ({ lead }: { lead: Lead }) => (
  <Card className="mb-6">
    <CardHeader>
      <CardTitle>Benefits & Retirement</CardTitle>
    </CardHeader>
    <CardContent className="space-y-2">
      <div>
        <div className="font-medium">Healthcare Options</div>
        <div>
          {lead.healthcare_options?.length
            ? lead.healthcare_options.join(", ")
            : "None specified"}
        </div>
      </div>
      <div>
        <div className="font-medium">Retirement Accounts</div>
        <div>
          {lead.retirement_accounts?.length
            ? lead.retirement_accounts.join(", ")
            : "None specified"}
        </div>
      </div>
      <div>
        <div className="font-medium">Pension Status</div>
        <div className="capitalize">
          {lead.pension_status?.replace(/_/g, " ") || "Not specified"}
        </div>
      </div>
    </CardContent>
  </Card>
);